export const customerApplication = {
  analytics: {
    heap: false,
    googleTagManager: true
  },
  header: {
    questions: false,
    faq: true,
    contactUs: 'amount',
    stickyFor: ['personal', 'rates_terms', 'loan_offer', 'bank_account', 'additional_information', 'contract'],
    show_badge: true
  },
  useAmountModalForSessionExpiry: true,
};

export const ipDash = {
  analytics: {
    heap: false,
    googleTagManager: true
  }
};

export const customerHome = {
  analytics: {
    heap: false,
    googleTagManager: true
  },
  hideFooter: true
};

require("!!inline-loader!@amount/frontend-styles/src/images/partners/td/icons/icon-map.svg");
require("@amount/frontend-styles/src/images/logo/logo-norton-small.png");
require("@amount/frontend-styles/src/images/logo/logo-norton-large.png");
require("@amount/frontend-styles/src/images/partners/td/dec/fit-update/td-nordictrack.jpg");
require("@amount/frontend-styles/src/images/partners/td/logo/logo-td-nordictrack.svg");
require("@amount/frontend-styles/src/images/partners/td/dec/fit-update/td-proform.jpg");
require("@amount/frontend-styles/src/images/partners/td/logo/logo-td-proform.svg");
require("@amount/frontend-styles/src/images/partners/td/logo/logo-td-subline.png")